import SamskipResource from "SamskipResource";

class AlertsService {
  getAlertRoute = (req: any): SamskipPromise<any> => {
    return SamskipResource.post("SamskipAPI", `alerts/getAlertRoute`, "", req);
  };
}

export default new AlertsService();
